import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import logoSvg from '../assets/logo.svg';

const PendingApprovalPage: React.FC = () => {
  const { pendingEmail, pendingDisplayName, signOut } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 via-white to-gray-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md mx-auto text-center space-y-6">

        {/* Logo */}
        <div className="flex justify-center">
          <div
            className="w-16 h-16 rounded-xl flex items-center justify-center shadow-lg bg-white border-2"
            style={{ borderColor: '#011132' }}
          >
            <img src={logoSvg} alt="Rascal EPR" className="w-12 h-12 object-contain" />
          </div>
        </div>

        {/* Card */}
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
          <div
            className="p-8 text-white"
            style={{ background: 'linear-gradient(135deg, #011132 0%, #022050 100%)' }}
          >
            <div className="text-5xl mb-4">⏳</div>
            <h2 className="text-2xl font-bold mb-2">Access Request Pending</h2>
            <p className="opacity-90 text-sm">Your account is awaiting HR Admin approval</p>
          </div>

          <div className="p-8 space-y-4 text-left">
            {pendingDisplayName && (
              <p className="text-gray-700 font-semibold text-lg text-center">
                Hi, {pendingDisplayName} 👋
              </p>
            )}

            {pendingEmail && (
              <div className="bg-gray-50 rounded-lg px-4 py-3 text-sm text-gray-600 break-all text-center">
                {pendingEmail}
              </div>
            )}

            <p className="text-sm text-gray-500 leading-relaxed text-center">
              Your Microsoft 365 account has been verified. An HR Admin will review your request and assign your role to grant access to Rascal EPR.
            </p>

            <p className="text-xs text-gray-400 text-center">
              You'll be able to sign in automatically once approved — no further action needed.
            </p>

            <button
              onClick={signOut}
              className="w-full mt-4 py-2.5 px-4 rounded-lg border border-gray-200 text-gray-600 text-sm font-medium hover:bg-gray-50 transition-colors"
            >
              Sign out
            </button>
          </div>
        </div>

        <footer className="text-[10px] text-gray-400">
          © 2025 Developed by RHW | Rascal Republic | Samara Lombok
        </footer>
      </div>
    </div>
  );
};

export default PendingApprovalPage;
